import type { FormHTMLAttributes, ReactNode } from "react";
import { Box } from "@mui/material";
import { FilterLiveForm } from "react-admin";

export const receiptFilterCompactInputProps = {
  helperText: false,
  fullWidth: false,
  size: "small" as const,
};

export const receiptFilterDateFieldSx = {
  "& .MuiOutlinedInput-input": {
    py: 1,
  },
  "& input[type='date']": {
    lineHeight: 1.4375,
  },
} as const;

const filterFormSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1.5,
  rowGap: 1.5,
  alignItems: "center",
  width: "100%",
  "& .MuiFormControl-root": {
    my: 0,
    width: { xs: "100%", sm: "auto" },
  },
  "& .MuiOutlinedInput-root": {
    overflow: "hidden",
    bgcolor: "background.paper",
  },
} as const;

const FilterFormLayout = (props: FormHTMLAttributes<HTMLFormElement>) => (
  <Box component="form" {...props} sx={filterFormSx} />
);

export type ReceiptFilterLiveFormProps = {
  children: ReactNode;
};

/**
 * Renders inside `<List>` and syncs to the list query via FilterLiveForm + useListContext.
 */
export default function ReceiptFilterLiveForm({ children }: ReceiptFilterLiveFormProps) {
  return <FilterLiveForm formComponent={FilterFormLayout}>{children}</FilterLiveForm>;
}
